/**
 * en-GB messages added by Phase 1 task S2 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s2EnGB = {
    'error.member_fields_unavailable': 'Personal fields are not available yet, so those values could not be saved.',
    'error.member_group_not_repeat': 'Members can only be added to a repeat group.',
    'error.member_group_archived': 'This group is archived. Restore it before changing its members.',
    'error.member_email_taken': 'Another current member of this group already has that e-mail address.',
    'error.member_external_id_taken': 'Another member of this group already has that reference.',
    'error.member_dates': 'The end date cannot be before the start date.',
    'error.import_file_type': 'Upload a CSV or Excel (.xlsx) file.',
    'error.import_unreadable': 'That file could not be read. Check it is a valid CSV or Excel file and try again.',
    'error.import_too_many_rows': 'That file has more than {max} rows. Split it into smaller files.',
    'error.import_empty': 'The file has no rows to import.',
    'error.import_state': 'This import cannot be changed any more.',
    'error.import_running': 'This import is running and cannot be cancelled.',
    'error.import_file_gone': 'The uploaded file is no longer available. Upload it again.',
    'error.import_mapping_length': 'Choose where each column goes (or ignore it).',
    'error.import_mapping_duplicate': 'Each destination can only be used by one column.',
    'error.import_name_required': 'Map a column to the full name, or to first name and last name.',
    'error.import_match_column': 'Map a column for the field you chose to match existing members by.',
    'error.import_duplicate_key': 'This value is also on row {firstRow}.',
    'error.import_ambiguous_match': 'More than one existing member has this name, so the row cannot be matched.',
    'error.import_invalid_value': 'This value is not valid.',
    'error.import_name_required_row': 'A name is needed.',
    'error.import_bad_date': 'This is not a date in the format you chose.',
    'error.import_bad_status': 'The status must be current or archived.',
    'error.import_email_in_use': 'Another member already has this e-mail address.',
    'error.import_external_id_in_use': 'Another member already has this reference.',
    'error.import_field_unknown': 'This column is mapped to a personal field that does not exist.',
    'settings.members': 'Members',
    'settings.members.import': 'Import',
    'settings.members.import.maxFileMb': 'Largest import file (MB)',
    'settings.members.import.maxRows': 'Most rows in one import',
    'settings.members.lifecycle': 'Clean-up',
    'settings.members.lifecycle.archiveInactiveAfterDays': 'Archive members with no visit for this many days (0 = never)',
    'settings.members.lifecycle.deleteArchivedAfterDays': 'Delete archived members after this many days (0 = never)',
};
//# sourceMappingURL=s2.js.map